import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

const StyledTitleWrapper = styled.div`
  ${({
    theme: {
      colors: {
        grey: { grey_20 },
      },
    },
  }) => {
    return css`
      padding: 8px 18px 8px 18px;

      box-shadow: 0px 4px 4px rgba(46, 54, 61, 0.15);
      background-color: ${grey_20};
    `
  }}
`

const TitleWrapper: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  return <StyledTitleWrapper>{children}</StyledTitleWrapper>
}

export default TitleWrapper
